// extracted by mini-css-extract-plugin
module.exports = {"start_button":"StartButton_start_button__2J2fl"};